<template>
  <div id="contenedor-main-listado-avances-expediente-contrato">
    <desktop
      :listadoDocumentosPresentacion="listadoDocumentosPresentacion">
    </desktop>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';

export default {
  name: 'MainListadoAvances',
  props: {
    listadoDocumentosPresentacion: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
